import React, { useState, useEffect } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolderOutlined';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import TextInput from 'components/form/TextInput';
import ConnectCards from './ConnectCards';
import ConnectPoints from './ConnectWidgets';
import CreateModal from '../components/connect-card/CreateModal';
import useQueryParams from 'hooks/useQueryParams';
import PageWrapper from 'components/PageWrapper';
import Access, { ACTIONS, MODULES } from 'components/Access';
import useAlert from 'hooks/useAlert';
import toast from 'utils/toast';
import { getCategories, saveCategory } from 'services/categories.service';

const Labels = {};

const ConnectCardRoutes = ({ location, history }) => {
  const [tab, setTab] = useState('active');

  useEffect(() => {
    setTab('active');
  }, [location.pathname]);

  const onTabChange = (e, val) => {
    setTab(val);
  };

  return (
    <PageWrapper
      title={
        <Stack direction="row" alignItems="center" spacing={2}>
          <Switch>
            <Route path="/connect/cards">
              <span>Connect Cards</span>
            </Route>
            <Route path="/connect/widgets">
              <span>Connect Widgets</span>
            </Route>
          </Switch>
        </Stack>
      }
    >
      <Paper>
        <Box borderBottom={1} borderColor="divider">
          <Tabs value={tab} onChange={onTabChange}>
            <Tab value="active" label="Active" />
            <Tab value="deleted" label="Deleted" />
          </Tabs>
        </Box>
        <Switch>
          <Route exact path="/connect/widgets">
            <ConnectPoints tab={tab} />
          </Route>
          <Route exact path="/connect/cards">
            <ConnectCards tab={tab} />
          </Route>
        </Switch>
      </Paper>
    </PageWrapper>
  );
};

export default ConnectCardRoutes;
